// Install https://www.npmjs.com/package/react-medium-image-zoom


// Image.jsx
// ########################################

import React from 'react'
import { object, bool } from 'prop-types'
import Img from 'gatsby-image'
import Zoom from 'react-medium-image-zoom'

import styles from './Image.module.css'
import 'react-medium-image-zoom/dist/styles.css'

// Will not work without this!
const wrapperStyle = {
  width: '100%',
  height: '100%'
}

const Image = ({ fluid, alt, isZoomable }) => {
  return fluid && isZoomable ? (
    <Zoom className={styles.ZoomableMedia}>
      <Img style={wrapperStyle} fluid={fluid} alt={alt} />
    </Zoom>
  ) : (
    <Img fluid={fluid} alt={alt} />
  )
}

Image.defaultProps = {
  isZoomable: true
}

Image.propTypes = {
  fluid: object,
  isZoomable: bool
}

export default Image

// Image.module.scss
// ########################################

// :global {
//   [data-rmiz-wrap='visible'],
//   [data-rmiz-wrap='hidden'] {
//     width: 100%;
//     height: 100%;
//     display: block; // Not necessary, but it caused layout issues for me
//   }
// }